// ja strings for messages/library.ts. Same keys and {variables} as en there.
// {category} and {categoryLower} are both the Japanese name below (or the
// badge itself when it has none); titles follow searches like 「アニメ AIボイス」.
import type { Dict } from "../index";

const library: Dict = {
  "library.of": "{name}",
  "library.ofLanguage": "{name}",

  // SEO (pages/models.tsx and ModelSearchPageV2)
  "library.seo.title": "AIボイスライブラリ{filter} | Jammable",
  "library.seo.titleFiltered": "{filter}のAIボイス一覧 | Jammable",
  "library.seo.description":
    "9万3000以上のAIボイスモデルをチェック。アニメ、ゲーム、カートゥーン、K-POPなどのボイスでAIカバーを作成できます。新しいボイスが毎日追加されています。",
  "library.seo.ogDescription":
    "9万3000以上のAIボイスモデルをチェック。アニメ、ゲーム、カートゥーン、K-POPなどのボイスでAIカバーを作成できます。",
  "library.seo.listDescription":
    "JammableのAIボイス。AIカバー作成、テキスト読み上げに。最先端のAI技術で、5万以上のAIカバー用ボイスを用意しています。",
  "library.seo.listDescriptionFiltered":
    "{filter}のAIボイス。{filter}のAIカバー作成、テキスト読み上げに。最先端のAI技術で、5万以上のAIカバー用ボイスを用意しています。",
  "library.crumb.home": "ホーム",
  "library.crumb.library": "AIボイスライブラリ",
  "library.crumb.filter": "{category}のボイス",

  // ModelSearchPageV2
  "library.title": "ボイスライブラリ",
  "library.subtitle":
    "9万3000以上のボイス。タップして試聴するか、すぐにカバーを作成できます。",
  "library.train": "自分の声をトレーニング",
  "library.search": "ボイスを検索",
  "library.searchIn": "{categoryLower}のボイスを検索",
  "library.categoriesNav": "ボイスのカテゴリ",
  "library.all": "すべて",
  "library.moreCategories": "カテゴリをもっと見る",
  "library.fewerCategories": "カテゴリを閉じる",
  "library.collections": "コレクション",
  "library.collections.prev": "前のコレクション",
  "library.collections.next": "次のコレクション",
  "library.collection.voices": "{n}ボイス",
  "library.voicesIn": "{category}のボイス",
  "library.allVoices": "すべてのボイス",
  "library.empty.title": "ボイスが見つかりません",
  "library.empty.body":
    "別の名前で検索するか、自分でボイスをトレーニングしてみましょう。",
  "library.loadMore": "ボイスをもっと読み込む",

  // components/voices/VoiceSortTabs
  "library.sort.aria": "ボイスの並び替え",
  "library.sort.hot": "今日のトレンド",
  "library.sort.hot.short": "トレンド",
  "library.sort.top": "よく使われている順",
  "library.sort.top.short": "使用数順",
  "library.sort.liked": "いいねが多い順",
  "library.sort.liked.short": "いいね順",
  "library.sort.new": "新しい順",
  "library.sort.new.short": "新着",

  // CategoryHub
  "library.hub.title":
    "{category}のAIボイス：{category}の声でAIカバーを作成 | Jammable",
  "library.hub.titlePage": "{category}のAIボイス（{page}ページ目） | Jammable",
  "library.hub.description":
    "Jammableで{count}以上の{category}のAIボイスをチェック。好きなボイスを選んでAIカバーを作成したり、AIボイスチェンジャーとして使ったりできます。",
  "library.hub.descriptionPage":
    "Jammableの{category}のAIボイス（使用回数順）、{page}/{lastPage}ページ目。好きなボイスを選んでAIカバーを作成したり、AIボイスチェンジャーとして使ったりできます。",
  "library.hub.name": "{category}のAIボイス",
  "library.hub.crumbVoices": "AIボイス",
  "library.hub.voices": "ボイス",
  "library.hub.page": "{page}ページ目",
  "library.hub.h1": "{category}のAIボイス",
  "library.hub.intro":
    "{count}以上の{category}のAIボイスをチェック。好きなボイスを選んでAIカバーを作成したり、ボイスチェンジャーとして使ったりできます。",
  "library.hub.popular": "人気の{categoryLower}のボイス",
  "library.hub.mostUsedPage":
    "よく使われている{categoryLower}のボイス（{page}/{lastPage}ページ目）",
  "library.hub.noMatch": "検索に一致する{categoryLower}のボイスはありません。",
  "library.hub.openLibrary": "ボイスライブラリで開く",
  "library.hub.moreCategories": "ほかのカテゴリを見る",
  "library.hub.faq": "よくある質問",
  "library.hub.keepExploring": "さらに探す",
  "library.hub.moreWays": "Jammableでできるその他のこと。",
  "library.hub.link.aiCover": "AIカバー作成",
  "library.hub.link.voiceChanger": "AIボイスチェンジャー",
  "library.hub.link.allVoices": "すべてのAIボイスを見る",
  "library.hub.pages": "ページ",
  "library.hub.first": "最初",
  "library.hub.prev": "前へ",
  "library.hub.next": "次へ",
  "library.hub.last": "最後",
  "library.hub.faq1.q": "{category}のAIボイスとは？",
  "library.hub.faq1.a":
    "{category}のAIボイスは、{categoryLower}カテゴリのボイスモデルです。AIカバーを作ったり、自分の声を変えたりするのに使えます。Jammableには{count}以上あり、新しいボイスが毎日追加されています。",
  "library.hub.faq2.q": "{category}のAIボイスはどうやって使いますか？",
  "library.hub.faq2.a":
    "{category}のボイスを開き、使用する権利のある音声を追加（または自分で録音）して、生成ボタンを押します。Jammableがボーカルをそのボイスに変換し、数秒でカバーが完成します。",
  "library.hub.faq3.q": "{category}のボイスはいくつありますか？",
  "library.hub.faq3.a":
    "Jammableには現在{count}以上の{category}のAIボイスがあり、コミュニティが新しいボイスをアップロード・トレーニングすることで、ライブラリは毎日増えています。",

  // Category names, as they read in 「{category}のAIボイス」.
  "library.cat.public-figure": "有名人",
  "library.cat.music": "音楽",
  "library.cat.cartoon": "カートゥーン",
  "library.cat.gaming": "ゲーム",
  "library.cat.fictional": "フィクション",
  "library.cat.anime": "アニメ",
  "library.cat.influencer": "インフルエンサー",
  "library.cat.singer": "歌手",
  "library.cat.comedy": "お笑い",
  "library.cat.pop": "ポップ",
  "library.cat.youtuber": "YouTuber",
  "library.cat.tv-show": "テレビ番組",
  "library.cat.rap": "ラップ",
  "library.cat.fictional-character": "架空のキャラクター",
  "library.cat.movie": "映画",
  "library.cat.movies": "映画",
  "library.cat.funny": "おもしろ",
  "library.cat.kpop": "K-POP",
  "library.cat.k-pop": "K-POP",
  "library.cat.parody": "パロディ",
  "library.cat.animation": "アニメーション",
  "library.cat.animated": "アニメーション",
  "library.cat.rock": "ロック",
  "library.cat.vtuber": "VTuber",
  "library.cat.fantasy": "ファンタジー",
  "library.cat.game": "ゲーム",
  "library.cat.entertainment": "エンタメ",
  "library.cat.rapper": "ラッパー",
  "library.cat.horror": "ホラー",
  "library.cat.actor": "俳優",
  "library.cat.actors": "俳優",
  "library.cat.actress": "女優",
  "library.cat.meme": "ミーム",
  "library.cat.action": "アクション",
  "library.cat.educational": "教育",
  "library.cat.hip-hop-rap": "ヒップホップ/ラップ",
  "library.cat.hip-hop": "ヒップホップ",
  "library.cat.adventure": "アドベンチャー",
  "library.cat.tv": "テレビ",
  "library.cat.female": "女性",
  "library.cat.male": "男性",
  "library.cat.superhero": "スーパーヒーロー",
  "library.cat.drama": "ドラマ",
  "library.cat.sci-fi": "SF",
  "library.cat.science-fiction": "SF",
  "library.cat.alternative": "オルタナティブ",
  "library.cat.metal": "メタル",
  "library.cat.technology": "テクノロジー",
  "library.cat.indie": "インディー",
  "library.cat.celebrity": "セレブ",
  "library.cat.fiction": "フィクション",
  "library.cat.american": "アメリカ",
  "library.cat.british": "イギリス",
  "library.cat.australian": "オーストラリア",
  "library.cat.latino": "ラテン",
  "library.cat.mexico": "メキシコ",
  "library.cat.villain": "悪役",
  "library.cat.politics": "政治",
  "library.cat.president": "大統領",
  "library.cat.animal": "動物",
  "library.cat.animals": "動物",
  "library.cat.dog": "犬",
  "library.cat.cat": "猫",
  "library.cat.sports": "スポーツ",
  "library.cat.wrestling": "プロレス",
  "library.cat.streamer": "配信者",
  "library.cat.country": "カントリー",
  "library.cat.robot": "ロボット",
  "library.cat.sound-effects": "効果音",
  "library.cat.historical": "歴史",
  "library.cat.folk": "フォーク",
  "library.cat.r-b": "R&B",
  "library.cat.rnb": "R&B",
  "library.cat.jazz": "ジャズ",
  "library.cat.reggaeton": "レゲトン",
  "library.cat.electronic": "エレクトロニック",
  "library.cat.pop-music": "ポップス",
  "library.cat.comic": "コミック",
  "library.cat.demon": "悪魔",
  "library.cat.news": "ニュース",
  "library.cat.artist": "アーティスト",
  "library.cat.artistas": "アーティスト",
  "library.cat.cantantes": "歌手",
  "library.cat.cantante": "歌手",
  "library.cat.personajes": "キャラクター",
  "library.cat.character": "キャラクター",
  "library.cat.singing": "歌",
  "library.cat.mystery": "ミステリー",
  "library.cat.christmas": "クリスマス",
  "library.cat.sitcom": "シットコム",
  "library.cat.pirate": "海賊",
  "library.cat.toy": "おもちゃ",
  "library.cat.classic": "クラシック",
  "library.cat.art": "アート",
  "library.cat.poetry": "詩",
  "library.cat.food": "フード",
  "library.cat.fashion": "ファッション",
  "library.cat.family": "ファミリー",
  "library.cat.podcast": "ポッドキャスト",
  "library.cat.radio": "ラジオ",
  "library.cat.ai": "AI",
  "library.cat.artificial-intelligence": "人工知能",
  "library.cat.song": "歌",
  "library.cat.ringtone": "着信音",
  "library.cat.web-series": "ウェブシリーズ",
  "library.cat.idol": "アイドル",
  "library.cat.dub": "吹き替え",
  "library.cat.80s": "80年代",
  "library.cat.indie-games": "インディーゲーム",
  "library.cat.game-show": "クイズ番組",
  "library.lang.japanese": "日本語",
  "library.lang.japenese": "日本語",
  "library.lang.korean": "韓国語",
  "library.lang.spanish": "スペイン語",
  "library.lang.english": "英語",
  "library.lang.french": "フランス語",
  "library.lang.italian": "イタリア語",
  "library.lang.german": "ドイツ語",
  "library.lang.deutsch": "ドイツ語",
  "library.lang.russian": "ロシア語",
  "library.lang.hebrew": "ヘブライ語",
  "library.lang.chinese": "中国語",
  "library.lang.arabic": "アラビア語",
  "library.lang.swedish": "スウェーデン語",
  "library.lang.polish": "ポーランド語",
  "library.lang.turkish": "トルコ語",
  "library.lang.finnish": "フィンランド語",
  "library.lang.greek": "ギリシャ語",
  "library.lang.indonesian": "インドネシア語",
  "library.lang.thai": "タイ語",
  "library.lang.hungarian": "ハンガリー語",
  "library.lang.filipino": "フィリピン語",
  "library.lang.malaysian": "マレー語",
  "library.lang.portuguese": "ポルトガル語",
  "library.lang.brasileiro": "ブラジルポルトガル語",
  "library.lang.pt-br": "ブラジルポルトガル語",
  "library.lang.romanian": "ルーマニア語",
  "library.lang.hindi": "ヒンディー語",
  "library.lang.dutch": "オランダ語",
  "library.lang.czech": "チェコ語",
  "library.lang.vietnamese": "ベトナム語",
};

export default library;
